// extracted by mini-css-extract-plugin
module.exports = {"error-label":"FormError_error-label__1qNHj","error":"FormError_error__3Q66f"};